export default {
	searchParams: SEARCH_PARAMS(),
	masterList: [],
	masterPagingInfo: {
		currentPage: 1,
		pageUnit: 10,
		totalSize: 0
	},
	currentMstValue: CURRENT_MST_VALUE(),
	detailList: [],
	detailPagingInfo: {
		currentPage: 1,
		pageUnit: 10,
		totalSize: 0
	},
	ckuPrvsList: [], //검사항목 selectBox
	ckuWayList: [], //검사방법 selectBox
	ckuWayList2: [], //검사방법2 selectBox
	utmList: [], //단위 selectBox
	useYnList: [], //사용여부 selectBox
	jgmtCrtnList: [], //판정기준 selectBox
	useYnDtlList: [], //사용여부(상세쪽)  selectBox
	passDsqfList: [], //합불기준(상세쪽)  selectBox
	//pageArray: [10, 30, 50, 100]
	/* 팝업관련 시작 */

	searchPopupMParams: SEARCH_POPUP_M_PARAMS(),
	searchPopupDParams: SEARCH_POPUP_D_PARAMS(),
	searchPopupMPagingInfo: SEARCH_POPUP_M_PAGING_INFO(),
	masterPopupList: [],
	detailPopupList: [],
	moveListMaps: [],
	selectedRow: {}
};

function SEARCH_PARAMS() {
	return {
		partNo: '',
		ckuPrvsCd: '',
		prvsClCd: ''
	};
}

function CURRENT_MST_VALUE() {
	return {
		partNo: '',
		ckuPrvsCd: '',
		prvsClCd: '',
		prvsClNm: '',
		ckuWayCd: ''
	};
}

function SEARCH_POPUP_M_PARAMS() {
	return {
		partNo: ''
	};
}

function SEARCH_POPUP_M_PAGING_INFO() {
	return {
		currentPage: 1,
		endPage: 1,
		pageUnit: 30,
		startPage: 1,
		totalSize: 1
	};
}

function SEARCH_POPUP_D_PARAMS() {
	return {
		partNo: ''
	};
}

//외부에서 참조하기 위해 export진행
export { SEARCH_PARAMS, CURRENT_MST_VALUE, SEARCH_POPUP_M_PARAMS, SEARCH_POPUP_M_PAGING_INFO, SEARCH_POPUP_D_PARAMS };
